import { isDocumentMediaPath } from '../redux/downloadDocumentMedia';
import { useAuthenticatedDocumentMedia } from './useAuthenticatedDocumentMedia';

const normalizeMediaUrl = (url) => {
    if (!url) {
        return null;
    }
    if (typeof url === 'string') {
        return url;
    }
    if (typeof url === 'object' && typeof url.url === 'string') {
        return url.url;
    }
    return null;
};

/**
 * Resolves a relative API path to a full URL (non-authenticated resources).
 */
export const resolvePublicMediaUrl = (url) => {
    url = normalizeMediaUrl(url);
    if (!url) {
        return null;
    }
    if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('blob:')) {
        return url;
    }

    const apiBasePath = process.env.REACT_APP_API_ENDPOINT || '';
    if (!apiBasePath) {
        return url;
    }

    let resolved = apiBasePath + url;
    if (resolved.includes('/api') && apiBasePath.endsWith('/api')) {
        resolved = resolved.replace('/api', '');
    }

    return resolved;
};

/**
 * Returns an img-ready src: blob URL for /documents/media/* (Bearer auth), public URL otherwise.
 */
export const useResolvedMediaSrc = (url) => {
    url = normalizeMediaUrl(url);
    const isMediaPath = Boolean(url && isDocumentMediaPath(url));
    const {
        blobUrl,
        loading,
        error,
        isMediaPath: isAuthenticatedMedia,
        downloadHref,
    } = useAuthenticatedDocumentMedia(isMediaPath ? url : null);

    const src = isMediaPath ? blobUrl : resolvePublicMediaUrl(url);
    const ready = Boolean(url && src && !loading);

    return {
        src,
        loading: isMediaPath && loading,
        error,
        isMediaPath: isAuthenticatedMedia,
        ready,
        hasUrl: Boolean(url),
        downloadHref,
    };
};
